module.exports = __webpack_public_path__ + "static/media/image_step2.f3039b3a.png";